import React from 'react';
     import '/vercel/path0/docs/guide/mobile-library.md?watch=parent';
export const demos = {
  'docs-guide-mobile-library-demo-0': {
    component: React.memo(React.lazy(async function() {
  /**
 * title: demo 预览器示例
 * description: |
 *  和默认主题一样可以为 demo 配置介绍文案。
 *
 *  且相较 dumi 1 新增了 `compact`（配置为 `true` 时没有内边距）和 `background`（修改背景色）配置项的支持。
 */ const { default: React } = await import('react');
return {
    default: ()=>/*#__PURE__*/ React.createElement("button", {
            type: "button",
            style: {
                padding: '6px 14px',
                color: '#fff',
                border: 0,
                background: '#1677ff'
            }
        }, "主按钮")
};

})),
    asset: {
  "type": "BLOCK",
  "id": "docs-guide-mobile-library-demo-0",
  "refAtomIds": [],
  "dependencies": {
    "index.tsx": {
      "type": "FILE",
      "value": "import React from 'react';\n\nexport default () => (\n  <button\n    type=\"button\"\n    style={{\n      padding: '6px 14px',\n      color: '#fff',\n      border: 0,\n      background: '#1677ff',\n    }}\n  >\n    主按钮\n  </button>\n);"
    },
    "react": {
      "type": "NPM",
      "value": "18.3.1"
    }
  },
  "entry": "index.tsx",
  "description": "和默认主题一样可以为 demo 配置介绍文案。\n\n且相较 dumi 1 新增了 compact（配置为 true 时没有内边距）和 background（修改背景色）配置项的支持。",
  "title": "demo 预览器示例"
},
    context: {
  "react": require('react')
},
    renderOpts: {
          
          compile: async (...args) => {
            return (await import('/vercel/path0/dist/client/misc/reactDemoCompiler.js')).default(...args);
          },
        },
  },
};